import { loadView } from '@/router'

export default [
  {
    path: 'legacy-accounts',
    name: 'reports-legacy-accounts',
    component: loadView('Application/Reports/LegacyAccounts'),
    showInAlfred: true,
    alfredTitle: 'Reports - Legacy Accounts'
  },
  {
    path: 'legacy-invoice',
    name: 'reports-legacy-invoice',
    component: loadView('Application/Reports/LegacyInvoice'),
    showInAlfred: true,
    alfredTitle: 'Reports - Legacy Invoice'
  },
  {
    path: 'legacy-sales',
    name: 'reports-legacy-sales',
    component: loadView('Application/Reports/LegacySales'),
    showInAlfred: true,
    alfredTitle: 'Reports - Legacy Sales'
  },
  {
    path: 'legacy-freight',
    name: 'reports-legacy-freight',
    component: loadView('Application/Reports/LegacyFreight'),
    showInAlfred: true,
    alfredTitle: 'Reports - Legacy Freight'
  }
]
